import React from "react";
import { Table } from "reactstrap";
import { Checkbox, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { reverseServiceTypeMap } from "../../Constant/serviceTypeConstants";

const checkboxSx = {
  color: "rgba(57, 181, 74, 1)",
  "&.Mui-checked": { color: "rgba(57, 181, 74, 1)" },
};

const CombinationTable = ({
  combinations,
  onToggleKiosk,
  onToggleActive,
  onRemove,
  showClient = false,
  showCity = false,
  showServiceType = false,
  showCarType = false,
  showTerminal = false,
  showDriverPayout = false,
  showDriverCredit = false,
  onToggleDriverPayout,
  onToggleDriverCredit,
}) => {
  const hasTerminalData = showTerminal && combinations.some((c) => c.terminal);

  return (
    <Table bordered hover responsive>
      <thead style={{ backgroundColor: "#f5f5f5" }}>
        <tr>
          <th>#</th>
          <th>Package Name</th>
          {showClient && <th>Client</th>}
          {showCity && <th>City</th>}
          {showServiceType && <th>Service Type</th>}
          {showCarType && <th>Car Type</th>}
          {hasTerminalData && <th>Terminal</th>}
          {showDriverPayout && <th style={{ textAlign: "center" }}>Driver Payout</th>}
          {showDriverCredit && <th style={{ textAlign: "center" }}>Driver Credit</th>}
          <th style={{ textAlign: "center" }}>Enable for Kiosk</th>
          <th style={{ textAlign: "center" }}>{"Available {Yes / No}"}</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {combinations.map((item, index) => (
          <tr key={item.id}>
            <td>{index + 1}</td>
            <td>{item.name}</td>
            {showClient && <td>{item.corporateClientName}</td>}
            {showCity && <td>{item.serviceCityName}</td>}
            {showServiceType && <td>{reverseServiceTypeMap[item.serviceType]}</td>}
            {showCarType && <td>{item.carTypeName}</td>}
            {hasTerminalData && <td>{item.terminal || "-"}</td>}
            {showDriverPayout && (
              <td style={{ textAlign: "center" }}>
                <Checkbox
                  checked={item.isDriverPayout}
                  onChange={() => onToggleDriverPayout(item.id)}
                  sx={checkboxSx}
                />
              </td>
            )}
            {showDriverCredit && (
              <td style={{ textAlign: "center" }}>
                <Checkbox
                  checked={item.isDriverCredit}
                  onChange={() => onToggleDriverCredit(item.id)}
                  sx={checkboxSx}
                />
              </td>
            )}
            <td style={{ textAlign: "center" }}>
              <Checkbox
                checked={item.isKiosk}
                onChange={() => onToggleKiosk(item.id)}
                sx={checkboxSx}
              />
            </td>
            <td style={{ textAlign: "center" }}>
              <Checkbox
                checked={item.isActive}
                onChange={() => onToggleActive(item.id)}
                sx={checkboxSx}
              />
            </td>
            <td>
              <IconButton
                size="small"
                onClick={() => onRemove(item.id)}
                sx={{ color: "red" }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default CombinationTable;
